export default __webpack_public_path__ + "static/media/kgplex.bf8875c8.jpg";